import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
  card: {
    margin: "auto",
    border: 0,
    marginTop: 10,
    boxShadow: theme.palette.type === 'light' ? '0 10px 40px -10px rgb(0 64 128 / 20%)' : '0 3px 5px 2px #2020206b',
    transition: 3,
    borderRadius: 15,
    marginBottom: 25,
    maxWidth: 900,
    height: 620,
  },
  media: {
    height: 450,
},
}));


function Media(props) {
  const { loading = false } = props;
  const classes = useStyles();

  
  return (
    <Card className={classes.card}>
      <CardHeader
        avatar={
          loading ? (
            <Skeleton animation="wave" variant="circle" width={40} height={40} />
          ) : (
            <Skeleton animation="wave" variant="circle" width={40} height={40} />
          )
        }
        title={
          loading ? (
            <Skeleton animation="wave" height={10} width="80%" style={{ marginBottom: 6 }} />
          ) : (
            <Skeleton animation="wave" height={10} width="80%" style={{ marginBottom: 6 }} />
          )
        }
        subheader={loading ? <Skeleton animation="wave" height={10} width="40%" /> : <Skeleton animation="wave" height={10} width="40%" />}
      />
      {loading ? (
        <Skeleton animation="wave" variant="rect" className={classes.media} />
      ) : (
        <Skeleton animation="wave" variant="rect" className={classes.media} />
      )}

      <CardContent>
        {loading ? (
          <React.Fragment>
            <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
            <Skeleton animation="wave" height={10} width="80%" />
          </React.Fragment>
        ) : (
          <React.Fragment>
          <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
          <Skeleton animation="wave" height={10} width="80%" />
        </React.Fragment>
        )}
      </CardContent>
    </Card>
  );
}

Media.propTypes = {
  loading: PropTypes.bool,
};

export default function Facebook() {
  return (
    <div>
      <Media loading />
      <Media loading />
      <Media loading />
      <Media loading />
    </div>
  );
}